import BondTypes from './BondTypesContainer';

export default BondTypes;
